
import React from 'react';
import PropTypes from 'prop-types';

import Courses from '../Courses/Container.jsx';

export default class CoursesEnglishContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: [],
            schools: []
        };

    }

    componentWillMount() {
        this.setState({
            courses: this.props.courses,
            schools: this.props.schools,
        });
    }


    render() {
        return (
            <Courses
                courses={this.state.courses} schools={this.state.schools} lang="en" facets={window.defaultFacets}
            />
        );
    }
}

CoursesEnglishContainer.propTypes = {
    courses: PropTypes.array,
    schools: PropTypes.array
};